var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackedCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "61 60 78 80",
    viewBox: "61 60 78 80",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-mb08u5yf__item-kl57gfgh svg [data-color=\"1\"] {fill: #FFFFFF;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.4 119.8c-8.2 4.3-19 6.7-30.4 6.7s-22.2-2.4-30.4-6.7c-2.9-1.5-5.4-3.3-7.5-5.2-.7 1.6-1.1 3.2-1.1 4.9 0 11.3 17.5 20.5 39 20.5s39-9.2 39-20.5c0-1.7-.4-3.3-1.1-4.9-2.1 1.9-4.6 3.7-7.5 5.2z",
    fill: "#FFFFFF",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4 100.3c-8.2 4.3-19 6.7-30.4 6.7s-22.2-2.4-30.4-6.7c-2.9-1.5-5.4-3.3-7.5-5.2-.7 1.6-1.1 3.2-1.1 4.9 0 11.3 17.5 20.5 39 20.5s39-9.2 39-20.5c0-1.7-.4-3.3-1.1-4.9-2.1 1.9-4.6 3.7-7.5 5.2z",
    fill: "#FFFFFF",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 60c-21.5 0-39 9.2-39 20.5S78.5 101 100 101s39-9.2 39-20.5S121.5 60 100 60zm3.7 29.4v2.7h-7.5v-2.9c-4.3-.8-7.2-2.9-7.2-6V83h8.2c0 .8.7 1.8 3.1 1.8 1.8 0 2-.6 2-.8 0-.3-.4-.7-3.4-1.6-3.5-1.1-9.7-2.9-9.7-6.7 0-2.6 2.8-4.6 7-5.3v-2.8h7.5v2.9c4.1.8 7 3 7 6v.2h-8.2c0-.8-.6-1.8-2.7-1.8-1.6 0-1.8.6-1.8.8 0 .3.5.8 3.2 1.6 2.7.7 10 2.5 10 6.7-.2 2.7-3.2 4.7-7.5 5.4z",
    fill: "#FFFFFF",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedCoin);
export default __webpack_public_path__ + "static/media/stacked-coin.302aaeeb3fb0f7e01bf0fb604d82724f.svg";
export { ForwardRef as ReactComponent };